import {Component} from '@angular/core';
import {DomSanitizer, SafeStyle} from '@angular/platform-browser';
import {APP_CONFIG, AuthService, BlockAbstractComponent, ParserService} from '@gallaghercp/core-frontend';
import {BreakpointObserver} from '@angular/cdk/layout';

@Component({
    selector: 'core-block-home-hero-banner',
    templateUrl: './block-home-hero-banner.component.html',
    standalone: false
})

export class BlockHomeHeroBannerComponent extends BlockAbstractComponent {

    constructor(
        protected override parser: ParserService,
        protected override auth: AuthService,
        protected breakpoint: BreakpointObserver,
        private sanitizer: DomSanitizer,
    ) {
        super(
            parser,
            auth
        );
    }


    getBackground(url: string): SafeStyle {
        if (url && !url.includes('https://')) {
            url = APP_CONFIG.frontend + url;
        }
        return this.sanitizer.bypassSecurityTrustStyle('url(' + ['https://cdn.builtoncore.com', url].join('/') + ')');
    }

}
